const hitsLineHeight = 14
const talkLineHeight = 24
export const hitsLineHeightPx = `${hitsLineHeight}px`
export const talkLineHeightPx = `${talkLineHeight}px`
export const userRowHeightPx = `${hitsLineHeight + talkLineHeight}px`
export const userRowSpacingPx = '4px'
